export type Teammate = {
  name: string;
};

export const teamMates: Array<Teammate> = [
  {
    name: "Andreas",
  },
  {
    name: "Peter",
  },
];

export type LunchChoice = {
  name: string;
};

export const lunchChoices: Array<LunchChoice> = [
  {
    name: "Fish",
  },
  {
    name: "Chicken",
  },
  {
    name: "Vegan",
  },
];

export type Activity = {
  name: string;
};

// export const activities: Array<Activity> = [
//   {
//     name: "Coffee tasting",
//   },
//   {
//     name: "Yoga class",
//   },
// ];

export type BookableDate = {
  date: Date;
  teammates: Array<Teammate>;
  activities: Array<Activity>;
};

export const bookableDates: Array<BookableDate> = [
  {
    date: new Date(2021, 7, 30),
    teammates: [{ name: "Andreas" }],
    activities: [
      {
        name: "Coffee tasting",
      },
      {
        name: "Yoga class",
      },
    ],
  },
  {
    date: new Date(2021, 7, 31),
    teammates: [{ name: "Jonas" }],
    activities: [{ name: "Movie night" }],
  },
  {
    date: new Date(2021, 8, 1),
    teammates: [{ name: "Peter" }],
    activities: [{ name: "Basketball" }],
  },
  {
    date: new Date(2021, 8, 2),
    teammates: [],
    activities: [],
  },
  {
    date: new Date(2021, 8, 3),
    teammates: [{ name: "Andreas" }, { name: "Peter" }],
    activities: [],
  },
  {
    date: new Date(2021, 8, 4),
    teammates: [],
    activities: [],
  },
  {
    date: new Date(2021, 8, 5),
    teammates: [],
    activities: [],
  },
];
